var map = {
	"./Dancing Othello 16mm - 1.jpg": 8068,
	"./Dancing Othello 16mm - 2.jpg": 2547,
	"./Dancing Othello 16mm - 4.jpg": 5469,
	"./Dancing Othello Still - 1 .jpg": 9121,
	"./Dancing Othello Still - 2.jpg": 8674,
	"./Dancing Othello Still - 3.jpg": 1343
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7452;